import { render, staticRenderFns } from "./CatalogProductEditPage.vue?vue&type=template&id=2205dbf5"
import script from "./CatalogProductEditPage.vue?vue&type=script&lang=js"
export * from "./CatalogProductEditPage.vue?vue&type=script&lang=js"
import style0 from "./CatalogProductEditPage.vue?vue&type=style&index=0&id=2205dbf5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports